/* global ShopPopUpURLs */

import {connect} from 'react-redux';
import classNames from 'classnames';

import {pgettext} from 'topmeteo/utils/i18n';

import {useClassName} from '../hooks';
import {getCurrentDate, getCurrentRegion} from '../selectors';

import Portal from './Portal';

const PageWrapperNode = document.getElementById('page-wrapper');

const ArchiveMode = {
    name: pgettext('test-notification', 'Archive mode'),
    detail: pgettext('test-notification', 'Access to all pictures/maps from the past!'),
};

const NoActiveSubscriptionMode = {
    name: pgettext('test-notification', 'No active subscription'),
    detail: pgettext('test-notification', 'Only archive available!'),
};

const OutOfSubscriptionMode = {
    name: ArchiveMode.name,
    detail: pgettext('test-notification', 'Forecast days not included in your subscription!'),
};

const LoginLabel = pgettext('test-notification', 'Please log in');
const BuyNowLabel = pgettext('test-notification', 'Buy now');

const getNotification = (date, region, isAnonymous, isSubscriber) => {
    if (isAnonymous) return {mode: ArchiveMode, href: ShopPopUpURLs.login, label: LoginLabel};
    if (isSubscriber === false) return {mode: NoActiveSubscriptionMode, href: ShopPopUpURLs.shop, label: BuyNowLabel};
    if (date.available && region.available) return null;
    if (region.available) return {mode: OutOfSubscriptionMode, href: ShopPopUpURLs.abos, label: BuyNowLabel};
    return {mode: ArchiveMode, href: null, label: null};
};

const useNotification = (date, region, isAnonymous, isSubscriber) => {
    const notification = getNotification(date, region, isAnonymous, isSubscriber);

    useClassName(PageWrapperNode, 'is-testing', Boolean(notification));

    return notification;
};

const TestNotifications = ({date, region, isAnonymous, isSubscriber, panelOpen}) => {
    const notification = useNotification(date, region, isAnonymous, isSubscriber);

    if (notification === null) return null;

    const {mode, href, label} = notification;

    return (
        <Portal container="header-area">
            <div id="test-notifications" className={classNames({'panel-open': panelOpen})}>
                <div className="notifications-inner info">
                    <p>
                        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                        {mode.name} <span className="landscape-only">- {mode.detail}</span>
                        {href && label && <a href={href}>{label}</a>}
                    </p>
                </div>
            </div>
        </Portal>
    );
};

const mapStateToProps = state => ({
    isAnonymous: state.isAnonymous,
    isSubscriber: state.isSubscriber,
    date: getCurrentDate(state),
    region: getCurrentRegion(state),
    panelOpen: state.panelOpen === 'config-header',
});

export default connect(mapStateToProps)(TestNotifications);
